// extracted by mini-css-extract-plugin
export default {"small":"styles_small__qwVkU","classic":"styles_classic__HX91I","headerText":"styles_headerText__iHAh7"};